import vars from '../global/vars.js';

function loadMore(loadMoreBtn, target, loader, popState = false) {
    const totalPages = loadMoreBtn.dataset.total;
    const loadUrl = loadMoreBtn.href;
    const loadType = loadMoreBtn.dataset.type;

    let nextURL;
    let nextPage = loadMoreBtn.dataset.next;

    if (nextPage <= totalPages) {
        vars.body.classList.add('working');
        loader.classList.add('show');
        loadMoreBtn.classList.add('hide');

        // Only update histroy if exists and not fired by popState
        if (history.pushState && !popState) {
            history.pushState({}, '', loadUrl);
        }

        // Get cards
        fetch(loadUrl).then((response) => response.text()).then((html) => {
            // Convert the HTML string into a document object
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Get the image file
            const cards = doc.querySelectorAll('.js-card');

            cards.forEach((card) => {
                target.appendChild(card);
                card.classList.add(`card--page-${nextPage}`);
            });

            nextPage++;
            loadMoreBtn.dataset.next = nextPage;

            nextURL = `${vars.site}/${loadType}/page/${nextPage}`;
            loadMoreBtn.href = nextURL;

            if (nextPage > totalPages) {
                loadMoreBtn.setAttribute('disabled', true);
                loadMoreBtn.href = '#';
            }
        }).catch((err) => {
            // There was an error
            console.warn('Something went wrong.', err);
        })
            .then(() => {
                const loadedCards = target.querySelectorAll(`.card--page-${nextPage - 1}`);
                let timeout = 100;

                loadedCards.forEach((card) => {
                    timeout += 50;
                    card.classList.add('fade');

                    setTimeout(() => {
                        card.classList.add('fade-in');
                    }, timeout);
                });

                vars.body.classList.remove('working');
                loader.classList.remove('show');
                loadMoreBtn.classList.remove('hide');
            });
    }
}

const initloadMore = (loreMoreDiv, loadMoreBtn) => {
    if (loadMoreBtn) {
        const loader = document.querySelector('.js-loader');

        document.addEventListener('click', (event) => {
            if (event.target === loadMoreBtn) {
                event.preventDefault();
                loadMore(loadMoreBtn, loreMoreDiv, loader);
            }
        });
    }
};

export { initloadMore as default };
